// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VUEy","largestCol":"styles_largestCol__1EMk6","smallestCol":"styles_smallestCol__aR8VJ"};